import React from 'react';
import styles from './Instructions.module.css';

const steps = [
    {
        number: 1,
        title: 'Choisir',
        description: 'Choisissez un produit ou des produits',
    },
    {
        number: 2,
        title: 'Commander',
        description: 'Envoyer nous un message pour passer votre commande',
    },
    {
        number: 3,
        title: 'Obtenir',
        description: 'Réserver votre article(s) pour ramassage ou livraison tout droite à votre porte!',
    },
];

export const Instructions: React.FC = () => {
    return (
        <section className={styles.container}>
            <h2 className={styles.title}>Comment ça fonctionne</h2>
            <div className={styles.grid}>
                {steps.map((step) => (
                    <div key={step.number} className={styles.card}>
                        <div className={styles.stepBadge}>{step.number}</div>
                        <h3 className={styles.cardTitle}>{step.title}</h3>
                        <p className={styles.cardDescription}>{step.description}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Instructions;